<template>
  <HomeCommonLayout>
    <template #content>
      <RenewalContent>
        <AxGrowContent />
      </RenewalContent>
    </template>
  </HomeCommonLayout>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import AxGrowContent from "~~/codepresso-renewal/content/AxGrowContent.vue";
import { useSeoMeta } from "~/composables/useSeoMeta";

const { getCanonical, getHreflangLinks } = useSeoMeta();

useHead({
  title: "AX Grow: AI 자동화 내재화 교육 | 코드프레소",
  meta: [
    { name: "description", content: "현장 맞춤 교육, 실제 업무 공동 구축, 사내 확산 설계까지 세 단계로 조직 스스로 AI 자동화를 실행하는 역량을 남깁니다." },
    { name: "title", content: "AX Grow: AI 자동화 내재화 교육 | 코드프레소" },
    { name: "robots", content: "index,follow" },
    { property: "og:title", content: "AX Grow: AI 자동화 내재화 교육 | 코드프레소" },
    { property: "og:description", content: "현장 맞춤 교육, 실제 업무 공동 구축, 사내 확산 설계까지 세 단계로 조직 스스로 AI 자동화를 실행하는 역량을 남깁니다." },
  ],
  link: [...getHreflangLinks.value, { rel: "canonical", href: getCanonical.value }],
});
</script>

<style>
/* renewal 의 임베드 빌드 산출물(codepresso-renewal/embed). 모든 셀렉터가
   `.renewal-root` 를 요구하므로 헤더·푸터로 새지 않는다.
   로딩 순서는 renewal 원본과 같게 main → 페이지 전용 → mobile 로 둔다. */
@import "../../codepresso-renewal/embed/css/main.css";
@import "../../codepresso-renewal/embed/css/pages/ax-grow.css";
@import "../../codepresso-renewal/embed/css/mobile.css";
</style>
